import questModel from 'components/quests/questModel'
import { getCachedAnswer, getCachedQuest, getCachedUser } from 'state/cache'
import { resolveQuestParentQuestId } from 'state/questAncestors'
import { getStreamName } from 'components/filters/StreamName'
import type { UpTarget } from 'lib/panelUpTarget'

// Who the panel on the left is, for the back arrow's tooltip.
export function describePanelFilter(filter: any): string {
    if (!filter) return 'the previous panel'
    if (filter.questId) {
        const name = (getCachedQuest(String(filter.questId)) as any)?.parent?.user?.name
        return name ? `${name}'s thread` : 'the previous thread'
    }
    const user = filter.user ? getCachedUser(filter.user) : null
    return getStreamName(filter, user, true) || 'the previous panel'
}

// The crumb before a thread: its parent thread, or its channel.
export function resolveUpTarget(quest: any): UpTarget | null {
    if (!quest) return null
    const parentQuestId = resolveQuestParentQuestId({
        questId: quest.id != null ? String(quest.id) : null,
        parentQuestId: quest.parent_quest_id,
        parentId: quest.parent_id,
        parentAnswer: quest.parent,
        getAnswerById: id => getCachedAnswer(String(id)),
    })
    if (parentQuestId) {
        const parentQuest: any = getCachedQuest(parentQuestId)
        const name = parentQuest?.parent?.user?.name
        return {
            filter: { questId: parentQuestId, answerId: quest.parent_id },
            label: name ? `${name}'s thread` : 'the parent thread',
        }
    }
    const streamFilter = questModel.channelFilter(quest)
    if (!streamFilter) return null
    return {
        filter: streamFilter,
        label: getStreamName(streamFilter, null, true, quest.team || null) || 'the channel',
    }
}
